export default __webpack_public_path__ + "static/media/T_64_mobile.cfaccf93.jpg";